import { ReactElement } from 'react';

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

import Competition from '../../types/Competition';
import { formatEnumLabel } from '../../utils/utils';
import GratiDirectoryItem from '../common/GratiDirectoryItem';

interface CompetitionListItemProps {
  competition: Competition;
  isDividerDisplayed?: boolean;
}

export default function CompetitionListItem({ competition, isDividerDisplayed = false }: CompetitionListItemProps): ReactElement {

  const secondaryParts = [
    competition.format && formatEnumLabel(competition.format),
    competition.scoring && formatEnumLabel(competition.scoring),
    competition.isTeam ? `Team (${competition.teamSize ?? '?'})` : 'Individual',
  ].filter(Boolean);

  return (
    <GratiDirectoryItem
      to={`/competition/${competition.itemId}`}
      divider={isDividerDisplayed}
      slots={{
        icon: <EmojiEventsIcon />,
        primary: competition.name ?? '(unnamed)',
        secondary: secondaryParts.join(' · '),
      }}
      slotProps={{
        icon: { hideBreakpoint: 'xs' },
        secondary: { hideBreakpoint: 'xs' },
      }}
    />
  );
}
